// @ts-nocheck
/* eslint-disable */
import React, { useEffect, useState } from 'react';

import { CircularProgress } from '@material-ui/core';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';

import { uploadMultipleStopsApi } from 'app/operations/stations/station-api';
import { useTypedSelector } from 'helpers';
import { getIsSuperAdmin } from 'selectors';

interface Props {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}

const UploadStopsModal: React.FC<Props> = ({ isOpen, setOpen }) => {
  const intl = useIntl();
  const currentLanguageCode =
    localStorage.getItem('EASY_MOBILITY_LANGUAGE') || 'en-us';

  const [isUploading, setIsUploading] = useState(false);
  const isSuperAdmin = useTypedSelector(getIsSuperAdmin);

  useEffect(() => {
    const handleBeforeUnload = e => {
      if (isUploading) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    if (isUploading) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isUploading]);

  const close = () => {
    if (isUploading) return;
    setOpen(false);
  };

  const handleFileUpload = async e => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsUploading(true);
    try {
      await uploadMultipleStopsApi(file);
      toast.success(intl.formatMessage({ id: 'successUploadStops' }));
      setOpen(false);
    } catch (err: any) {
      const data = err?.response?.data;
      let message = data?.message || err?.message || 'Upload failed';
      if (Array.isArray(message)) {
        message = message.join(' | ');
      }
      toast.error(String(message), {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
      });
    } finally {
      setIsUploading(false);
      e.target.value = '';
    }
  };

  const handleTemplateDownload = () => {
    const headers = isSuperAdmin
      ? [
          'command',
          'stops_id',
          'en_name',
          'ar_name',
          'stop_code',
          'station_code',
          'log',
          'lat',
          'org_en_name',
        ]
      : [
          'command',
          'stops_id',
          'en_name',
          'ar_name',
          'stop_code',
          'station_code',
          'log',
          'lat',
        ];

    const sampleRow = isSuperAdmin
      ? [
          'add',
          '',
          'Stop One',
          'موقف واحد',
          'WAYZ123',
          'ABC123',
          '31.235',
          '30.045',
          'Org Name',
        ]
      : [
          'add',
          '',
          'Stop One',
          'موقف واحد',
          'WAYZ123',
          'ABC123',
          '31.235',
          '30.045',
        ];

    const ws = XLSX.utils.aoa_to_sheet([headers, sampleRow]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stops');
    XLSX.writeFile(wb, 'Stops_Template.xlsx');
  };

  return (
    <Modal show={isOpen} onHide={close} style={{ zIndex: 9999969 }}>
      {isUploading ? (
        <Modal.Body>
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              margin: '2px',
            }}
          >
            <CircularProgress style={{ width: 50 }} />
          </div>
        </Modal.Body>
      ) : (
        <>
          <Modal.Body>
            <label
              htmlFor="stops-file-upload"
              className=" upload-style-btn-label mt-3"
            >
              <FileUploadIcon /> {intl.formatMessage({ id: 'UploadFile' })}
            </label>

            <input
              id="stops-file-upload"
              type="file"
              accept=".csv,.xls,.xlsx"
              onChange={handleFileUpload}
              style={{ display: 'none' }}
              disabled={isUploading}
            />

            <button
              type="button"
              className="download-style-btn"
              onClick={handleTemplateDownload}
            >
              <DownloadIcon />
              {intl.formatMessage({ id: 'DownloadTemplate' })}
            </button>
          </Modal.Body>

          <Modal.Footer
            style={{
              direction: currentLanguageCode === 'en-us' ? 'ltr' : 'rtl',
            }}
          >
            <button
              type="button"
              className="download-style-btn"
              onClick={close}
            >
              {intl.formatMessage({ id: 'Cancel' })}
            </button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export { UploadStopsModal };
